// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jumbotron{background-repeat:no-repeat;background-size:cover;overflow:hidden}.jumbotron .display-5{position:relative}.jumbotron .display-5:after,.jumbotron .display-5:before{background-color:#fff;content:\"\";height:2px;margin:0 auto;position:absolute;top:50%;width:1000%}.jumbotron .display-5:before{right:105%}.jumbotron .display-5:after{left:105%}@media(min-width:576px){.jumbotron{padding:5rem 2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
